/** Follow fiscal redirect: unclassified origin → typed child document. */

export function resolveCanonicalDocumentId(record) {
  const redirectId = (record?.redirect_target_document_id || '').trim();
  const docId = (record?.document_id || '').trim();
  if (redirectId && redirectId !== docId) return redirectId;
  return docId || null;
}

export async function fetchCanonicalDocumentRecord(callApi, buildQuery, documentId) {
  const data = await callApi(buildQuery(documentId));
  let record = data?.getDocumentById;
  if (!record) return null;

  const canonicalId = resolveCanonicalDocumentId(record);
  if (canonicalId && canonicalId !== documentId) {
    const redirected = await callApi(buildQuery(canonicalId));
    record = redirected?.getDocumentById || record;
  }
  return record;
}
